export const SET_SEARCH_RESULT_SUCCESS = 'SET_SEARCH_RESULT_SUCCESS';
export function setSearchResult(payload){
    return({type:SET_SEARCH_RESULT_SUCCESS, payload: payload});
}

export const SET_RESOURCE_PDF_URL = 'SET_RESOURCE_PDF_URL';
export function setResourcePDFURL(payload){
    return({type:SET_RESOURCE_PDF_URL, payload: payload});
}

export const RESET_RESOURCE_PDF_URL = 'RESET_RESOURCE_PDF_URL';
export function resetResourcePDFURL(){
    return({type:RESET_RESOURCE_PDF_URL});
}

export const SET_PDF_URL_LOADER = 'SET_PDF_URL_LOADER';
export function setPDFURLLoader(payload){
    return({type:SET_PDF_URL_LOADER, payload: payload});
}

export const RESET_PDF_URL_LOADER = 'RESET_PDF_URL_LOADER';
export function resetPDFURLLoader(){
    return({type:RESET_PDF_URL_LOADER });
}

export const RESET_SEARCH = 'RESET_SEARCH';
export function resetSearch(){
    return({type:RESET_SEARCH});
}


// WEBPACK FOOTER //
// ./src/_actions/search.actions.js